import { Injectable, inject } from '@angular/core';
import { AnalyticsDataPopulateService } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { ProfileSelectorHelperComponent } from './profile-selector-helper.component';

@Injectable({
  providedIn: 'root'
})
export class ProfileSelectorSupportComponent extends ProfileSelectorHelperComponent {
  private analyticsDataPopulateService = inject(AnalyticsDataPopulateService);

  innerWidth!: number;
  advisorBanner = false;
  queryParamKeys: string[] = [];
  paramsToIgnore: string[] = [];
  queryParams = {} as { [key: string]: string };

  assignRefreshURL(): void {
    if (this.profileSelectorFacadeService.fromProfileStandAlone()) {
      this.refreshURL = this.profileSelectorFacadeService.refreshURL;
      this.paramsToIgnore = this.profileSelectorFacadeService.paramsToIgnore;
      this.queryParamKeys = this.profileSelectorFacadeService.queryParamKeys;
      this.queryParams = this.profileSelectorFacadeService.queryParams;
    }
  }

  checkAlertAdvisorContainer(): void {
    this.advisorBanner = !!document.querySelector(
      '.alert-advisory-main-container'
    );
  }

  getInnerWidth(): void {
    this.innerWidth = window.innerWidth;
  }

  onClickLogout(event?: Event): void {
    if (event?.currentTarget) {
      this.analyticsDataPopulateService.populateAnalyticsData(
        event.currentTarget as HTMLElement,
        event
      );
    }
    this.profileSelectorFacadeService.logout();
  }

  focusTab(focusable: HTMLElement[], e: KeyboardEvent): void {
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const shift = e.shiftKey;
    if (shift) {
      if (e.target === first) {
        last.focus();
        e.preventDefault();
      }
    } else {
      if (e.target === last) {
        first.focus();
        e.preventDefault();
      }
    }
  }

  initializeDataForStandAlonePage(
    enableMachCore: boolean,
    setModalPropertiesCallback?: () => void
  ): void {
    if (this.profileSelectorFacadeService.fromProfileStandAlone()) {
      this.profileSelectorFacadeService.enableProfileSelector(
        this.profileSelectorFacadeService.fromProfileStandAlone()
      );
      this.defaultSelectAccount(
        (this.profileSelectorAdapterHelperService.firstName = ''),
        'P',
        0
      );
      if (setModalPropertiesCallback) {
        setModalPropertiesCallback();
      }
      this.assignRefreshURL();
    } else {
      if (enableMachCore) {
        this.profileSelectorFacadeService.enableProfileSelector(false);
      }
    }
  }

  setupModalProperties(): void {
    this.checkAlertAdvisorContainer();
    this.modalContainerFocus();
    this.getInnerWidth();
  }

  handleResizeOperations(): void {
    this.getInnerWidth();
    this.checkAlertAdvisorContainer();
  }

  handleProfileAnalytics(event: Event): void {
    if (event?.currentTarget) {
      this.analyticsDataPopulateService.populateAnalyticsData(
        event.currentTarget as HTMLElement,
        event,
        undefined,
        true
      );
    }
  }
}
